<template>
  <v-autocomplete
    v-model="select"
    :items="items"
    :filter="filter"
    :label="label"
    item-value="code"
    :error-messages="errorMessages"
    :clearable="clearable"
  >
    <template v-slot:selection="data">
      {{ data.item.code }}
    </template>
    <template v-slot:item="data">
      {{ data.item.code }}
    </template>
  </v-autocomplete>
</template>

<script>
/*
 * model input value format:
 *   currency
 */
export default {
  name: "CurrencyField",

  props: {
    value: {
      type: String
    },
    label: {
      type: String,
      mandatory: true
    },
    errorMessages: {
      type: Array,
      default: () => []
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      select: null,
      search: null
    };
  },

  methods: {
    filter(item, queryText) {
      const text = item.code.toLowerCase();
      return text.indexOf(queryText.toLowerCase()) > -1;
    },

    setValue(value) {
      this.select = value;
    }
  },

  watch: {
    select: function() {
      this.$emit("input", this.select);
    },

    value: function() {
      this.setValue(this.value);
    }
  },

  computed: {
    items: function() {
      return this.$store.state.data.listCurrencies;
    }
  },

  mounted() {
    this.$store.dispatch("data/fetchCodes", "currencies");

    this.setValue(this.value);
  }
};
</script>

<style scoped>

</style>